import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { NewAccessCardService } from '../service/new-access-card.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-cards-list-result',
  templateUrl: './cards-list-result.component.html'
})
export class CardsListResultComponent implements OnInit {

  @Input() idRequest: string;
  EntryCard: any;
  statusCard: string;


  constructor(private _snackBar: MatSnackBar,
              private route: ActivatedRoute  ,
              private spinner: NgxSpinnerService,
              private dataApi: NewAccessCardService,
              public dialog: MatDialog) {
    this.route.snapshot.paramMap.get('id');
    this.idRequest = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {

    this.getCardDetail(this.idRequest);
  }

  getlang() {
    return sessionStorage.getItem("lang");
  }

  getCardDetail(id) {
    this.spinner.show("loading");
    this.dataApi.getCardConfirm( id
    ).subscribe((data: any) => {
      this.EntryCard=data;
      this.spinner.hide("loading");
    }, (err) => {
      this.spinner.hide("loading");
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
        });
      }
    });
  }

}
